__turbopack_context__.v({
  "dark": "FollowUs-module__Fw2tfa__dark",
  "light": "FollowUs-module__Fw2tfa__light",
  "social": "FollowUs-module__Fw2tfa__social",
  "socials": "FollowUs-module__Fw2tfa__socials",
});
